import React from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import CategoryPoints from '../Tables/CategoryPoints';
import PartnerPoints from '../Tables/PartnerPoints';

const SurgeReport = ({ data }) => {
  return (
    <Card className="card-inner">
      <CardHeader>
        <h5>Surge Reports</h5>
      </CardHeader>
      <CardBody>
        <Container className="mt-4">
          <Row>
            <CategoryPoints data={data} />
            <PartnerPoints data={data} />
          </Row>
        </Container>
      </CardBody>
    </Card>
  );
};

export default SurgeReport;
